import styled from "styled-components";

export const PremiumPubReviewWrapper = styled.div`
  padding: 20px 16px 50px;
`;

export const PremiumPubReviewHeader = styled.div`
  display: flex;
  justify-content: space-between;

  > .write {
    color: var(--Black-200, #b7b7b7);
    font-size: 13px;
    font-weight: 500;
  }
`;

export const PremiumPubReviewList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;

  > .more {
    width: 100%;
    height: 48px;
    border-radius: 8px;
    background: #d9d9d9;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
